import React from "react";
import { Box, Card, Stack, Typography, useTheme } from "@mui/material";

export interface MobileDashboardSectionProps {
  title?: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  sx?: any;
  cardSx?: any;
  disableCard?: boolean;
}

export const MobileDashboardSection: React.FC<MobileDashboardSectionProps> = ({
  title,
  action,
  children,
  sx,
  cardSx,
  disableCard = false,
}) => {
  const theme = useTheme();

  const content = disableCard ? (
    children
  ) : (
    <Card
      elevation={0}
      sx={{
        borderRadius: "18px",
        border: `1px solid ${
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.08)"
            : "rgba(0,0,0,0.06)"
        }`,
        backgroundColor:
          theme.palette.mode === "dark"
            ? "rgba(30, 41, 59, 0.7)"
            : "#ffffff",
        boxShadow:
          theme.palette.mode === "dark"
            ? "0 4px 20px rgba(0,0,0,0.3)"
            : "0 4px 20px rgba(0,0,0,0.04)",
        p: 2,
        overflow: "hidden",
        ...cardSx,
      }}
    >
      {children}
    </Card>
  );

  return (
    <Box sx={{ width: "100%", ...sx }}>
      {(title || action) && (
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: 1.5, px: 0.5 }}
        >
          {typeof title === "string" ? (
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                fontSize: "1.05rem",
                color: theme.palette.text.primary,
                letterSpacing: "-0.01em",
              }}
            >
              {title}
            </Typography>
          ) : (
            title
          )}
          {action}
        </Stack>
      )}
      {content}
    </Box>
  );
};
